import { render } from "./SVGSaveAsCopy.vue?vue&type=template&id=6df7ff8a"
import script from "./SVGSaveAsCopy.vue?vue&type=script&lang=js"
export * from "./SVGSaveAsCopy.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__